import React from 'react'
import { useSelector } from 'react-redux'
import { Backdrop, CircularProgress } from '@mui/material'
import { withStyles } from '@mui/styles'
import { style } from 'styles'

function Loading({ classes }) {
	const isLoading = useSelector(state => state.ui.loading > 0)

	return (<Backdrop className={classes.loading} open={isLoading} onClick={() => {}}>
		<CircularProgress color="primary" />
	</Backdrop>)
}

export default withStyles(style)(Loading)
